import { _ } from '@ngx-translate/core';

/**
 * Translation keys consumed by installed `@freesixtyfive/*` packages
 * (`fe-login-process`, `fe-user-management`) whose UI components render these
 * labels at runtime. The app supplies the translations in `public/i18n/*.json`,
 * but the references live in `node_modules`, which `ngx-translate-extract` does
 * not scan — so without this `_()` marker the `--clean` step would delete them.
 *
 * Keep this list in sync with the packages' i18n contract. It is the registry
 * for "keys we provide to external consumers"; in-app dynamic/literal keys are
 * declared with `_()` at their own usage site instead (see AGENTS.md → i18n).
 */
_([
  // @freesixtyfive/fe-login-process — login / forgot / reset / change password UI
  'error.loginFailed',
  'error.loginFailedDetail',
  'error.forgotPasswordFailed',
  'error.forgotPasswordFailedDetail',
  'label.login',
  'label.toLogin',
  'label.email',
  'label.password',
  'label.confirmPassword',
  'label.passwordRequired',
  'label.passwordDoesNotMatch',
  'label.submit',
  'label.loading',
  'label.forgotPassword',
  'label.forgotPasswordSentDescription',
  'label.resetPassword',
  'label.resetPasswordConfirmDescription',
  'label.setPassword',
  'label.setPasswordConfirmDescription',
  'label.changePassword',
  'label.changePasswordDescription',
  'label.changePasswordMailSent',
  // @freesixtyfive/fe-user-management — user table actions
  'label.cancel',
  'placeholder.selectAll',
]);
